






import { Vue, Component } from 'vue-property-decorator';

import RespectOutline from '~/components/icons/RespectOutline.vue';

@Component({
  components: { RespectOutline },
})
export default class RespectCard extends Vue {
}
